import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { AsyncPaginate } from 'react-select-async-paginate';
import { ACCOUNT_API } from '@app/utils/apiUrl';
import { Get } from '@app/utils/httpProvider';

const toAccountOption = (item) => {
    const info = item.accountAuthInfo || item.AccountAuthInfo || item;
    const username = item.username || item.Username || item.userName || item.UserName || '';
    const name = info.fullName || info.FullName || [info.lastName || info.LastName, info.middleName || info.MiddleName, info.firstName || info.FirstName].filter(Boolean).join(' ');
    const value = item.id || item.Id || item.accountId || item.AccountId;
    return { value, label: [name, username].filter(Boolean).join(' - ') || value };
};

const useAccount = (id) => useQuery(['chungChiAccount', id], () => Get(ACCOUNT_API.GET_BY_ID_ACCOUNT, id), {
    enabled: !!id,
    staleTime: 300000
});

const loadAccounts = async (search, loaded, additional) => {
    const page = additional?.page || 1;
    const result = await Get(ACCOUNT_API.GET_PAGING_ACCOUNT_NOT_MENU, null, {
        Keyword: search, PageIndex: page, PageSize: 20
    });
    if (!result) throw new Error('Không tải được danh sách tài khoản');
    const payload = result.data || result;
    const collection = payload.data || payload;
    const items = collection.$values || collection;
    if (!Array.isArray(items)) throw new Error('Dữ liệu tài khoản không hợp lệ');
    const total = result.totalRecords ?? payload.totalRecords;
    return {
        options: items.map(toAccountOption),
        hasMore: total != null ? page * 20 < total : items.length === 20,
        additional: { page: page + 1 }
    };
};

export const AccountCell = ({ accountId }) => {
    const query = useAccount(accountId);
    if (!accountId) return <span>-</span>;
    return <span>{query.data ? toAccountOption(query.data).label : query.isLoading ? 'Đang tải...' : accountId}</span>;
};

export const AccountField = ({ value, onChange, error }) => {
    const [selected, setSelected] = useState(null);
    const query = useAccount(value);
    const option = !value ? null : selected?.value === value ? selected : query.data ? toAccountOption(query.data) : { value, label: query.isLoading ? 'Đang tải tài khoản...' : value };
    return (
        <Form.Group as={Row} className="mb-3">
            <Form.Label htmlFor="chungChiAccount" className="col-sm-2 col-form-label">Tài khoản</Form.Label>
            <Col sm="10">
                <AsyncPaginate
                    inputId="chungChiAccount"
                    value={option}
                    loadOptions={loadAccounts}
                    additional={{ page: 1 }}
                    debounceTimeout={300}
                    isClearable
                    placeholder="Tìm và chọn tài khoản"
                    onChange={(item) => {
                        setSelected(item);
                        onChange(item?.value || '');
                    }}
                />
                {error && <div className="text-danger">{error}</div>}
            </Col>
        </Form.Group>
    );
};
